<template>
  <div class="goods_index">
    <el-breadcrumb separator="/" slot="breadcrumb" class="breadcrumb-bg">
      <el-breadcrumb-item >首页</el-breadcrumb-item>
      <el-breadcrumb-item >管理列表</el-breadcrumb-item>
    </el-breadcrumb>

      <div class="header-top-15">
          <el-card class="box-card" style="margin-top: 15px">
              <el-form  :model="form">
                  <el-form-item label="搜索">
                      <el-input size="medium" v-model="form.name" placeholder="账户名称" @input="search" style="width: 50%"></el-input>
                  </el-form-item>



              </el-form>
          </el-card>
      </div>


    <el-table
      :data="member_data"
      stripe
      style="width: 100%; margin-top: 10px"
      @selection-change="handleSelectionChange"
      ref="multipleTable"
    >
      <el-table-column prop="id" label="ID" type="selection"> </el-table-column>

      <el-table-column prop="username" label="账户" width="180">
        <template slot-scope="scope">
          <el-tooltip
            class="item"
            effect="light"
            :content="scope.row.username"
            placement="top-start"
          >
            <span>{{ scope.row.username }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="level" label="角色">
        <template slot-scope="scope">
          {{ scope.row.cn_name }}
        </template>
      </el-table-column>

      <el-table-column prop="nickname" label="昵称"> </el-table-column>


      <el-table-column label="操作" width="300">
        <template slot-scope="scope">
          <el-row >
            <el-col :span="8">
              <el-button type="danger" size="mini" @click="edit_state(scope.row,0)" v-if="scope.row.state=='1'">禁用</el-button>
            </el-col>
              <el-col :span="8">
                  <el-button size="mini" @click="edit_state(scope.row,1)" v-if="scope.row.state=='0'">启用</el-button>
              </el-col>
            <el-col :span="8">
              <el-button size="mini" type="primary" @click="edit(scope.row)">编辑</el-button>
            </el-col>
              <el-col :span="8">
                    <div v-if="scope.row.en_name==='super'"> </div>
                    <div v-else>
                        <el-button size="mini" type="primary" @click="del(scope.row)" >删除</el-button>
                    </div>






              </el-col>
          </el-row>

        </template>
      </el-table-column>
    </el-table>
    <div class="header-top-15">
      <el-card class="box-card">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="totalpages"
          @current-change="changePage"
        >
        </el-pagination>
      </el-card>
    </div>




  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  data() {
    return {
        form:{
            name:"",
            type:'',
        },
        member_data:[],
        totalpages:"",
        state:"",
      dialog_area_visible: false,

      multipleSelection: [],

      agent: false,

      page: 1,
    };
  },
  methods: {
    ...mapActions({
        getMemberIndexAction: "getMemberIndexAction",
        editMemberAction:"editMemberAction",
        deleteMemberAction:"deleteMemberAction"
    }),




      del(row){
        this.deleteMemberAction({id:row.id})
      },


      edit_state(row,state) {
          this.state=state

          this.editMemberAction({type:2,id:row.id,state:state})

    },
    edit(row) {
      const id = row.id;
      this.$router.push({
        name: "member_edit",
        params: { id: id },
      });
    },

    handleClick(tab, event) {
      console.log(tab, event);
    },
    changePage(e) {
      this.page = e;
      this.changePageData(e);
    },
    changePageData(page) {
      this.page = page;
      console.log("tag", this.page);
      this.getMemberIndexAction({ page: page,name:this.form.name });
    },
      search(){

          this.changePageData(1)
      }
  },
  created() {
    this.getMemberIndexAction({ page: this.page,name:this.form.name });
  },
  //tableData
  computed: mapState({
    tableData: (state) => state.member.result,
  }),
  watch:{
      tableData(val){
          if(val.code==200){
              this.member_data=val.data
              this.totalpages=val.totalpages
          }
          if(val.code==304){
            let text=""
              if(this.state=="1"){
                  text="启用成功"
              }
              if(this.state=="0"){
                  text="禁用成功"
              }
              this.$message({
                  message:text,
                  type:"success"

              })
              this.getMemberIndexAction({ page: 1,name:this.form.name });
          }
          if(val.code==402){
              this.$message({
                  message:"删除失败",


              })

          }
          if(val.code==305){

              this.$message({
                  message:"删除成功",
                  type:"success"

              })
              this.getMemberIndexAction({ page: 1,name:this.form.name });
          }

      },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.dialog-footer {
  text-align: center;
  background-color: gainsboro;
  padding: 0.3rem;
}
</style>
